import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { useAppSelector } from '../../store/hooks';

const UpdateNotice: React.FC = () => {
	const updateTitle = useAppSelector((state) => state.system.updateNoticeTitle);
	const updateDesc = useAppSelector((state) => state.system.updateNoticeDesc);

	const getNoticeDesc = () => {
		if (updateDesc) {
			if (typeof updateDesc === 'string') {
				return <>{updateDesc}</>;
			} else if (updateDesc.length > 0) {
				return (
					<>
						{updateDesc[0]}
						{updateDesc.slice(1).map((desc) => {
							return (
								<React.Fragment key={`update-desc-${desc}`}>
									<br></br>
									{desc}
								</React.Fragment>
							);
						})}
					</>
				);
			}
		} else {
			return <></>;
		}
	};

	return (
		((updateTitle && updateTitle.length > 0) || (updateDesc && updateDesc.length > 0)) && (
			<Alert severity="warning" sx={{ '& .MuiAlert-icon': { fontSize: '2rem' }, fontSize: '1.1rem' }}>
				{updateTitle && <AlertTitle sx={{ fontWeight: 'bold', fontSize: '1.4rem' }}>{updateTitle}</AlertTitle>}
				{getNoticeDesc()}
			</Alert>
		)
	);
};

export default UpdateNotice;
